import ClientIdentityForm from './ClientIdentityForm'

const Create = () => {
    return (
        <ClientIdentityForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Brand identity created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create brand identity',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating brand identity...',
                },
            }}
        />
    )
}

export default Create
